import { BoelsGenericState, ProductSearchPage } from '@boels/models';
import { createReducer, on } from '@ngrx/store';
import {
  loadGlobalProductSearchPage,
  loadGlobalProductSearchPageFail,
  loadGlobalProductSearchPageSuccess,
} from '../actions/global-product-search.action';

export interface GlobalProductSearchState extends BoelsGenericState {
  entities: ProductSearchPage;
  errorMessage?: string;
}

export const productSearchInitialState: GlobalProductSearchState = {
  entities: {},
  loading: false,
  success: false,
  error: false,
  errorMessage: undefined,
};

export const reducer = createReducer(
  productSearchInitialState,
  on(loadGlobalProductSearchPage, (state) => ({
    ...state,
    loading: true,
    success: false,
    error: false,
  })),
  on(
    loadGlobalProductSearchPageSuccess,
    (state, { productSearchPage, currentPage }) => {
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        entities:
          currentPage === 0
            ? productSearchPage
            : {
                ...productSearchPage,
                products: [
                  ...(state?.entities?.products ?? []),
                  ...(productSearchPage.products ?? []),
                ],
              },
      };
    },
  ),
  on(loadGlobalProductSearchPageFail, (state, { errorMessage }) => ({
    ...state,
    error: true,
    loading: false,
    success: false,
    errorMessage,
  })),
);
